import { watchGetTemplatesInPopup } from 'containers/Admin/PageBuilder/TemplatesInPopup/sagas/watchGetTemplatesInPopup';
import { watchLoadMoreTemplatesInPopup } from 'containers/Admin/PageBuilder/TemplatesInPopup/sagas/watchLoadMoreTemplateInPopup';

export const sagaTemplatePopup = [watchGetTemplatesInPopup, watchLoadMoreTemplatesInPopup];
